export default __webpack_public_path__ + "static/media/tcic.85db7aab.jpg";